import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import INVOICE_STATUSES from './InvoiceStatuses';
import SovosToolbarDropdown from 's1-ui/sovos-toolbar/components/SovosToolbarDropdown';

const sharedStyle = { fontSize: 13, width: 200 };

const InvoiceStatusSelector = ({ value, onStatusChange }) => {
  const handleStatusChange = ev => {
    onStatusChange(ev.target.value);
  };

  return (
    <SovosToolbarDropdown
      value={ value }
      onChange={ handleStatusChange }
      style={ { ...sharedStyle, height: 50, borderRight: '1px solid #e2e2e2', paddingRight: 10 } }
      className={ 'status-selector' }
    >
      { INVOICE_STATUSES.map(status => (
        <MenuItem
          value={ status.value }
          key={ status.value }
          style={ sharedStyle }
        >
          { status.primaryText }
        </MenuItem>
      )) }
    </SovosToolbarDropdown>
  );
};

InvoiceStatusSelector.propTypes = {
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]).isRequired,
  onStatusChange: PropTypes.func.isRequired,
};

export default InvoiceStatusSelector;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceStatusSelector/InvoiceStatusSelector.js